/**
 * loading\alert\actionsheet\
 */
const state = {
    loadingV: {
        tip: "",
        show: false
    },
    success: {
        tip: "",
        show: false
    },
    alert_little: {
        show: false,
        msg: "",
        top: "",
    },
    myAlert: {
        show: false,
        msg: "",
    },
    prompt: {
        show: false,
        title: "请输入密码",
        cancel: "取消",
        confirm: "确认",
        type: "password",
        placeholder: "请输入密码",
        value: "",
        isConfirm: false,
        complete: ""
    }
};

const actions = {
    aLoadingV({commit}, {show, tip = ''}) {
        commit('mLoadingV', {show, tip})
    },
    aMyAlert({commit}, {show, msg = ''}) {
        commit('mMyAlert', {show, msg})
        // return new Promise((resolve, reject) => {
        //     try {
        //         commit('mMyAlert', {show, msg});
        //         setTimeout(function () {
        //             commit('mMyAlert', {show: false});
        //             resolve()
        //         }, 4000);
        //     } catch (e) {
        //         reject(e)
        //     }
        // });
    },
    aSuccess({commit}, {tip = ''}) {
        return new Promise((resolve, reject) => {
            try {
                commit('mLoadingV', {
                    show: false,
                    tip: tip
                });
                commit('mSuccess', {
                    show: true,
                    tip: tip
                });
                setTimeout(function () {
                    commit('mSuccess', {
                        show: false,
                        tip: tip
                    });
                    resolve()
                }, 800);
            } catch (e) {
                reject(e)
            }
        });

    },
    aAlert_little({commit}, {msg = '', top = ''}) {
        return new Promise((resolve, reject) => {
            try {
                commit('mAlert_little', {show: true, msg, top});
                setTimeout(function () {
                    commit('mAlert_little', {
                        show: false,
                    });
                    resolve()
                }, 500);
            } catch (e) {
                reject(e)
            }
        });
    },
    aPrompt({commit}, {show, title = '', cancel = '', confirm = '', type = '', placeholder = '', value = '', isConfirm = false, complete = ""}) {
        commit('mPrompt', {show, title, cancel, confirm, type, placeholder, value, isConfirm, complete});
    },
};

const mutations = {
    mLoadingV(state, {show, tip = ''}) {
        state.loadingV = {
            show, tip
        };
    },
    mMyAlert(state, {show, msg = ''}) {
        state.myAlert = {
            show, msg
        };
    },
    mSuccess(state, {show, tip = ''}) {
        state.success = {
            show, tip
        };
    },
    mAlert_little(state, {show, msg, top}) {
        state.alert_little = {show, msg, top};
    },
    mPrompt(state, {show, title, cancel, confirm, type, placeholder, value, isConfirm, complete}) {
        title === '' && (title = state.prompt.title);
        cancel === '' && (cancel = state.prompt.cancel);
        confirm === '' && (confirm = state.prompt.confirm);
        type === '' && (type = state.prompt.type);
        placeholder === '' && (placeholder = state.prompt.placeholder);
        value === '' && (value = state.prompt.value);
        complete === '' && (complete = state.prompt.complete);

        state.prompt = {show, title, cancel, confirm, type, placeholder, value, isConfirm, complete};
    },
};

const getters = {
    getMLoadingV: (state) => {
        return state.loadingV
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
